import { Modal, styled } from '@mui/material';
import { BASE_MODAL_Z_INDEX } from 'style/constants';

export const StyledModal = styled(Modal)({
  maxWidth: '650px',
  height: '65%',
  maxHeight: '650px',
  margin: 'auto',
  outline: 'none',
  zIndex: BASE_MODAL_Z_INDEX,
  '& .MuiModal-backdrop': {
    backdropFilter: 'blur(2px)',
  },
});
